const languages = {
  DE: 'de',
  FR: 'fr',
  IT: 'it',
};

export default languages;
